import React from "react";
import {
  Button,
  Card,
  CardBody, Col, CustomInput,
  Form, Input, Label, Row,
} from "reactstrap";
import {observer} from "mobx-react-lite";
import {FormattedMessage, useIntl} from "react-intl";
import GroupSelect from "../../elements/groups/GroupSelect";
import DimensionsMultiSelect from "../../elements/dimensions/multi-select/dimensionsMultiSelect";
import TagSelect from "../../elements/tags/TagSelect";
import {browserHistory} from "mobx-state-router";
import { FileIcon, defaultStyles } from 'react-file-icon';
import MediaFilePreview from "@scanbuy-inc/cmp_v2_pages/mediafile/src/componets/MediaFilePreview";
import {MediaFilePreviewState} from "@scanbuy-inc/cmp_v2_pages/mediafile/src/componets/MediaFilePreviewState";
import {getFileCategory, getCacheBustedUrl} from "../../../utils/common";
import PdfQuickPreview from "../../../utils/PdfQuickPreview";
const EditMediaFileForm = observer(({editMediaFileState}) => {
  // const routerStore = useRouterStore();
  const intl = useIntl();
  const hiddenFileInput = React.useRef(null);
  const handleImageUploadClick = event => {
    hiddenFileInput.current.click();
  };

  //TODO: PATTERN VIOLATION - shouldCallOnWaitForMediaFileUpload called on every render
  // See correct pattern: Call in route onEnter (src/routes/codes/index.js) or as MST action
  editMediaFileState.shouldCallOnWaitForMediaFileUpload()

  const renderFileIcon = (fileFormat) => {
    return<div className="media-file-icon-small"> <FileIcon extension={fileFormat} {...defaultStyles[fileFormat]}/></div>};

const renderFilePreview = () => {
  const imageSrc = editMediaFileState.shouldRenderBase64NonBrowserConvertedFile() ?
    editMediaFileState.base64NonBrowserConvertedFile :
    getCacheBustedUrl(editMediaFileState?.mediaFile?.liveLinks?.original)
  const fileFormat = editMediaFileState?.mediaFile?.fileFormat
  const mediaFilePreviewState = MediaFilePreviewState.create({fileUrl:imageSrc, fileType: getFileCategory(fileFormat)});

  return <div className="media-file-preview-container">

    <MediaFilePreview store={mediaFilePreviewState}/>
  </div>
}
  return (
    <Card>
      <CardBody>

        <Form>
          <Row className="p-1">
            <Label sm={1} className="text-sm-right"><FormattedMessage
              id="createQr.groups.defaultMessage"/></Label>
            <Col sm={3}>
              <GroupSelect groupSelectStore={editMediaFileState.groupSelectStore}/>
            </Col>
            <Col sm={1} className="media-file-col-center-margin">
              <CustomInput
                type="switch"
                id="isGroupGlobal"
                name="isGroupGlobal"
                label={intl.formatMessage({id: 'qrDesign.create.groupOnly.defaultMessage',defaultMessage:"Only"})}
                checked={editMediaFileState?.isExclusivelyGroupOwned}
                onChange={() => editMediaFileState.toggleIsExclusivelyGroupOwned()}
              />
            </Col>
            {editMediaFileState?.dimensionsMultiSelectStore?.dimensionStore?.dimensionsEnabled && <Col sm={2} className="media-file-col-center-margin">
              <CustomInput
                type="switch"
                id="isDimensionAll"
                name="isDimensionAll"
                label={editMediaFileState?.dimensionsMultiSelectStore?.getLabelsWithPrefix(intl.formatMessage({id: 'qrDesign.create.dimensionAll.defaultMessage'}))}
                checked={editMediaFileState?.dimensionAll}
                onChange={() => editMediaFileState.toggleDimensionAll()}
              />
            </Col>}
            {editMediaFileState?.dimensionsMultiSelectStore?.dimensionStore?.dimensionsEnabled && editMediaFileState.isDimensionSelectVisible && <>
              <Col>
                <DimensionsMultiSelect dimensionMultiSelectState={editMediaFileState.dimensionsMultiSelectStore}/>
              </Col>
            </>}
          </Row>
          <Row className="p-1 mt-2">
            <Label sm={1} className="text-sm-right"><FormattedMessage id="createQr.tags.defaultMessage"/></Label>
            <Col>
              <TagSelect tagSelectStore={editMediaFileState?.tagSelectStore}/>
            </Col>
          </Row>
          <Row className="p-1 mt-2">
            <Label sm={1} className="text-sm-right"></Label>
            <Col>
              <>
                {/*<>*/}
                {/*  {mediaType === "images" && <div><FormattedMessage id="mediaFile.mediaFileEditForm.acceptedImagesFormats.defaultMessage"/></div>}*/}
                {/*  {mediaType === "videos" && <div><FormattedMessage id="mediaFile.mediaFileEditForm.acceptedVideosFormats.defaultMessage"/></div>}*/}
                {/*  {mediaType === "audios" && <div><FormattedMessage id="mediaFile.mediaFileEditForm.acceptedAudiosFormats.defaultMessage"/></div>}*/}
                {/*  {mediaType === "files" && <div><FormattedMessage id="mediaFile.mediaFileEditForm.acceptedFilesFormats.defaultMessage"/></div>}*/}
                {/*</>*/}
                  <FormattedMessage id="mediaFile.mediaFileEditForm.acceptedSingularFormat.defaultMessage" />{" "}
                  {editMediaFileState.acceptedFileFormat()}
              </>
              {editMediaFileState.usageIsContent()&&
                <><br/> <FormattedMessage id="mediaFile.mediaFileCreateForm.acceptedContentImageSize.defaultMessage"/></>
              }
              {editMediaFileState.usageIsQRImage() &&
                <>
                  {/*<FormattedMessage id="qrDesign.create.acceptedFormats.defaultMessage"/>*/}
                  <><br/> <FormattedMessage id="mediaFile.mediaFileCreateForm.acceptedQrImageSize.defaultMessage"/></>
                </>
              }
            </Col>
          </Row>
          {editMediaFileState.shouldRenderUploadNewFileButtonAndContent() &&
          <Row className="p-1 mt-2">
            <Col sm={1}></Col>
            <Col sm={1}>
              <Button id="uploadbg-btn" onClick={handleImageUploadClick}>
                <FormattedMessage id="qrDesign.create.upload.defaultMessage"/>
              </Button>
              <input
                type="file"
                name="FileImage"
                className="media-file-hidden-input"
                ref={hiddenFileInput}
                onChange={(event) => {
                  const selectedFile = event.target.files[0];
                  if (selectedFile) {
                    editMediaFileState.setSelectedImage(selectedFile, false,);
                    event.target.value = ''
                  }
                }}
              ></input>
            </Col>


            {editMediaFileState.shouldRenderStagedNewFileToUpload() &&
              <Col sm={5} className="media-file-col-flex">

                 <Col sm={3} className="text-right"><FormattedMessage id="mediaFile.mediaFileEditForm.replacementFile.defaultMessage"/></Col>
                {/*<Col sm={1}>*/}
                {/*</Col>*/}
                {editMediaFileState.shouldRenderImageForS3Upload() &&
                  <img
                    className="media-file-preview-container"
                    src={editMediaFileState.imagePreviewSrc()}
                  />
                }
                {editMediaFileState.shouldRenderFileIconForS3Upload() && renderFileIcon(editMediaFileState.mediaFile.fileFormat)
                }
                {editMediaFileState.shouldRenderStagedPDFToUpload() &&
                  editMediaFileState.fileForS3Upload?.type === "application/pdf" && (
                    <div className="media-file-preview-container">
                      <PdfQuickPreview file={editMediaFileState.fileForS3Upload}/>
                    </div>
                  )
                }

              </Col>
            }



            <Col sm={5} className="media-file-col-flex">
            {/*  <Col style={{width:"30px"}}>*/}
            {/*    <div style={{width:"30px"}}>*/}
            {/*    {(editMediaFileState.shouldRenderIcon()) && renderFileIcon(editMediaFileState.mediaFile.fileFormat)*/}
            {/*  }*/}
            {/*      </div>*/}
            {/*    {*/}
            {/*      (editMediaFileState.mediaFile.name.includes() !=="pdf") &&*/}
            {/*  <Col sm={2}>*/}
            {/*    {(editMediaFileState.shouldRenderImage()) &&  <img style={{width: "150px"}}*/}
            {/*          src={`${editMediaFileState.mediaFile.liveLinks.original}` || `${editMediaFileState.base64FileImage}`}/>}*/}
            {/*    </Col>*/}
            {/*    }*/}
            {/*    /!*<Col sm={1}>*!/*/}
            {/*    /!*  /!*<div>*!/*!/*/}
            {/*    /!*  <FontAwesomeIcon onClick={editMediaFileState.removeFile} style={{cursor: "pointer"}} icon={faTrash}*!/*/}
            {/*    /!*                   className="align-middle"/>*!/*/}
            {/*    /!*  /!*</div>*!/*!/*/}
            {/*    /!*</Col>*!/*/}
            {/*  </Col>*/}
              {editMediaFileState.shouldRenderStagedNewFileToUpload() &&
                <Col sm={3} className="text-right"><FormattedMessage id="mediaFile.mediaFileEditForm.fileToBeRemoved.defaultMessage"/></Col>
              }
            {editMediaFileState.shouldRenderFileThatHasBeenUploaded() && renderFilePreview()}
              {editMediaFileState.shouldRenderFileFailedToUploadBanner() &&
                <>
                  <div className="media-file-error-banner">
                    <strong>Failed to Upload file:</strong> Please try again.
                  </div>
                </>

              }
            </Col>

          </Row>
          }
          {editMediaFileState.shouldRenderFileIsProcessingBanner() &&
            <>
              <Row>
          <Col sm={2}></Col>
              <Col sm={4} className="media-file-col-flex">

            <div className="media-file-processing-banner">
              <FormattedMessage id="mediaFile.mediaFileEditForm.fileIsProcessing.defaultMessage"/>


            </div>
          </Col>
              </Row>
            </>
          }
          <Row className="p-1">
            <Col sm={1}></Col>
            <Label sm={1} >Usage</Label>
            <Col sm={1} className="media-file-col-center-margin" >
              <Input name="design"
                     disabled={true}
                     type="radio"
                     id="noDesign"
                     checked={editMediaFileState.usageIsContent()}
                     onClick={() => {
                       editMediaFileState.mediaFile?.setUsage("content")
                     }}
              />
              <Label check>
                <FormattedMessage id="mediaFile.content.defaultMessage"/>
              </Label>
            </Col>
            <Col sm={1} className="media-file-col-center-margin" >
              <Input name="design"
                     disabled={true}
                     type="radio"
                     id="noDesign"
                     checked={editMediaFileState.usageIsQRImage()}
                     onClick={() => {
                       editMediaFileState.mediaFile?.setUsage("qrImage")
                     }}
              />
              <Label check>
                <FormattedMessage id="mediaFile.qrImage.defaultMessage"/>
              </Label>
            </Col>
            {/*<Label sm={1} className="text-sm-right">Experience</Label>*/}
            {/*<Col sm={4}>*/}
            {/*  <Col sm={10}>*/}
            {/*    <CodeTypeSelect*/}
            {/*      codeTypeSelectStore={editMediaFileState.codeTypeSelectStore}*/}
            {/*      isMultiple={true}*/}
            {/*    />*/}
            {/*  </Col>*/}
            {/*</Col>*/}
            {/*<Label sm={2} className="text-sm-right">Propagate Image Changes</Label>*/}
            {/*<Col sm={1}>*/}
            {/*  <CustomInput*/}
            {/*    type="switch"*/}
            {/*    id="addGradient"*/}
            {/*    // checked={store.addGradient}*/}
            {/*    // onChange={()=>{store.toggleAddGradient(frameAndCaptionsStore)}}*/}
            {/*  />*/}
            {/*</Col>*/}



          </Row>
          <Row className="p-1">
            <Label sm={1} className="text-sm-right"><FormattedMessage id="mediaFile.name.defaultMessage"/></Label>
            <Col sm={11}>
              <div className="custom-controls-stacked">
                <Input
                  id="name"
                  name="name"
                  onChange={(data)=>{editMediaFileState.mediaFile?.updateInput("name",data)}}
                  value={editMediaFileState.mediaFile?.name || ""}
                />
              </div>
            </Col>
          </Row>


          <Row className="p-1">
            <Col sm={2}>
              <Button id="back-btn" color="secondary" onClick={browserHistory.goBack}>Back</Button>
            </Col>

            <Col sm={2}>
              {editMediaFileState.shouldRenderFileThatHasBeenUploaded() && editMediaFileState?.mediaFile?.liveLinks?.original && (
                <Button
                  id="download-btn"
                  color="secondary"
                  onClick={() => editMediaFileState.downloadFile()}
                >
                  <FormattedMessage id="mediaFile.download.defaultMessage" defaultMessage="Download"/>
                </Button>
              )}
            </Col>

            <Col sm={8} className="text-right">
              <div className="media-file-inline-text">This file is used in {editMediaFileState?.renderHowManyCodesThisFileIsUsed()} places</div>
              <Button
                disabled={editMediaFileState.isLoading}
                id="save-btn"
                outline color="primary"
                // disabled={createCodeViewState.isSaveDisabled()}
                      onClick={async () => {

                        const res = await editMediaFileState.updateLocationAndUploadFile()
                        if(res === "success"){
                        }
                      }}
              ><FormattedMessage id="mediaFile.update.defaultMessage"/></Button>
            </Col>
          </Row>
        </Form>
      </CardBody>
    </Card>
  );
})

export default EditMediaFileForm;
